
<template>
  <!--新增投诉原因-->
  <x-addEdit
    ref="addEdit"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
import { addEdit } from 'ant-design-vue-admin-x';
export default {
  mixins: [fetchSelect, addEdit],
  name: 'addReason',
  data () {
    return {
      parentId: undefined,
      formList: [
        {
          label: '投诉原因',
          inputType: 'input',
          options: [],
          placeholder: '请输入投诉原因',
          props: ['title', {
            rules: [
              { min: 1, max: 20, message: '投诉原因不超过20个字' },
              { required: true, message: '请输入投诉原因' }
            ]
          }]
        },
        {
          label: '应用位置',
          inputType: 'select',
          options: [],
          placeholder: '请选择应用位置',
          handle: this.reasonTypeChange,
          props: ['type', {
            rules: [{ required: true, message: '请选择应用位置' }]
          }]
        }
        // {
        //   label: '上级原因',
        //   inputType: 'cascader',
        //   options: [],
        //   placeholder: '请选择上级原因',
        //   props: ['parentId', { rules: [] }]
        // }
      ],
      formKey: {
        title: undefined,
        type: undefined,
        parentId: undefined
      },
      addParam: {
        url: '/housekeep/complaint/category/add',
        reqHandle: this.reqHandle,
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/housekeep/complaint/category/',
        resHandle: ''// this.editResHandle
      },
      detailParam: {
        url: '/housekeep/complaint/category/',
        resHandle: this.resHandle
      }
    };
  },
  created () {
    let query = this.$route.query;
    if (query.id) {
      this.formList[1].disabled = true;
    }
    if (query.parentId && query.type) {
      this.formList[1].disabled = true;
      // this.formList[2].disabled = true;
    }
    this.getSelect();
  },
  mounted () {
    this.addChild();
  },
  methods: {
    addChild () {
      let query = this.$route.query;
      if (query.parentId && query.type) {
        this.$refs.addEdit.form.setFieldsValue({
          type: query.type.toString(),
          parentId: query.parentId
        });
        this.getSelect(query.type);
        this.parentId = query.parentId;
      }
    },
    /* 获取下拉 */
    getSelect (reasonType, level) {
      this.$get({
        url: '/dict/data/dictType/comu_housekeep_complaint_category_type',
        params: {}
      }).then(({data}) => {
        this.formList[1].options = data;
      });
      // this.$get({
      //   url: '/housekeep/complaint/category/treeSelect',
      //   params: {}
      // }).then(({data}) => {
      //   this.formList[2].options = data;
      // });
    },
    /** 选择应用位置事件 */
    reasonTypeChange (e) {
      this.$refs.addEdit.form.resetFields(['parentId']);
      this.getSelect(e);
    },
    resHandle (res) {
      if (res && res.type) {
        this.getSelect(res.type, res.level);
        res.type = res.type && res.type.toString();
      }
      return res;
    },
    reqHandle (param) {
      param.parentId = this.parentId || param.parentId && param.parentId.toString() || undefined;
      console.log('处理请求前数据: ', param);
      param.type = param.type.toString();
      return param;
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>
